import { useAuth0 } from "@auth0/auth0-react";
import { ReactNode, useEffect } from "react";


type ProtectedRouteProps = {
  children: ReactNode;
};

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) {
      loginWithRedirect({
        appState: {
          returnTo: window.location.pathname,
        },
      });
    }
  }, [isAuthenticated, loginWithRedirect]);


  if (!isAuthenticated) {
    return <p>Redirecting...</p>;
  }

  return <>{children}</>;
}